import { styled } from "styled-components";
import { colorPalette, typeScale } from "../../../../utils/theme";
import { Col } from "react-bootstrap";

export const Section = styled.section`
  padding-top: 80px;
`;

export const StyledContainer = styled.div`
  @media (max-width: 767.98px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;

export const NavyBlock = styled.div`
  background: #0f1c4de5;
  border-radius: 16px;
  padding: 42px;
  width: 100%;

  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }

  @media (max-width: 767.98px) {
    padding: 16px;
  }
`;

export const LeftColumn = styled(Col)`
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 3vw, 24px);
`;

export const RightColumn = styled(Col)`
  display: flex;
  flex-direction: column;
`;

export const Badge = styled.div`
  color: ${colorPalette.blue400};
  text-transform: uppercase;
  ${typeScale.bodyXSMain};

  @media (max-width: 767.98px) {
    ${typeScale.bodyXXSMain};
  }
`;

export const Heading = styled.h2`
  margin: 0;
  color: ${colorPalette.white};
  ${typeScale.headingLMain};

  @media (max-width: 767.98px) {
    ${typeScale.headingSMMain};
  }
`;

export const LeadText = styled.p`
  margin: 0;
  color: ${colorPalette.blue200};
  ${typeScale.bodyLG};

  @media (max-width: 767.98px) {
    ${typeScale.bodyXS};
  }
`;

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AccordionItem = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);

  &:last-child {
    border-bottom: none;
  }
`;

export const AccordionHeader = styled.button`
  width: 100%;
  background: none;
  border: none;
  padding: clamp(16px, 3vw, 24px) 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  min-height: 44px;
  color: ${colorPalette.white};
  text-align: left;
  transition: all 0.2s ease;
  ${typeScale.bodyLGMain};

  &:hover {
    opacity: 0.8;
  }

  &:focus {
    outline: 2px solid ${colorPalette.blue300 || colorPalette.blue500};
    outline-offset: 2px;
  }

  @media (max-width: 767.98px) {
    ${typeScale.bodySMMain};
  }
`;

export const QuestionText = styled.span`
  flex: 1;
  padding-right: 16px;
`;

export const IconButton = styled.div<{ isOpen: boolean }>`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  transform: ${(props) => (props.isOpen ? "rotate(45deg)" : "rotate(0deg)")};
  flex-shrink: 0;
`;

export const AccordionPanel = styled.div<{ isOpen: boolean }>`
  max-height: ${(props) => (props.isOpen ? "500px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease;
  opacity: ${(props) => (props.isOpen ? "1" : "0")};
`;

export const AnswerContent = styled.div`
  padding: 0 0 clamp(16px, 3vw, 24px) 0;
  color: ${colorPalette.white};
  ${typeScale.bodyXS};

  @media (max-width: 767.98px) {
    ${typeScale.bodyXXS};
  }
`;
